import React from 'react';
import { Subheading } from '../Catalyst/heading';
import { Select } from '../Catalyst/select';
import { formatHomeAddress, useMember } from '../../Hooks/MemberContext';

/**
 * Which of the member's homes the page is about.
 *
 * `AuthMember::home_ids` is a list, so a member owning more than one
 * home is a supported case rather than an edge case — and every billing
 * read is per-home, so something has to choose. With one home this
 * renders the address as plain text; a dropdown to pick between one
 * option is noise.
 */
const HomeSelector: React.FC = () => {
  const { homes, selectedHome, selectHome } = useMember();

  if (homes.length === 0 || !selectedHome) {
    return null;
  }

  if (homes.length === 1) {
    return (
      <Subheading>
        {selectedHome.hoa_name} · {formatHomeAddress(selectedHome)}
      </Subheading>
    );
  }

  return (
    <div className="mt-2 max-w-xl">
      <label
        htmlFor="home-selector"
        className="block text-sm font-medium text-gray-900 dark:text-white"
      >
        Home
      </label>
      <Select
        id="home-selector"
        name="home"
        value={selectedHome.home_id}
        onChange={(e) => selectHome(e.target.value)}
        className="mt-1"
      >
        {homes.map((home) => (
          <option key={home.home_id} value={home.home_id}>
            {formatHomeAddress(home)} — {home.hoa_name}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default HomeSelector;
